function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.36696,-2.72244e-16,1.56699e-16,0.786798,-2.57672,0.775629)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.765,14.457L5.765,17.834L2.98,12.995L5.765,8.156L5.765,11.533L12.593,11.533L12.593,14.457L5.765,14.457Z",
    style: {
      fill: "rgb(232,75,64)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.031,7.831C7.038,6.483 7.05,5.136 7.068,3.789C7.077,3.533 7.122,3.282 7.21,3.041C7.439,2.416 7.935,1.908 8.554,1.663C8.811,1.562 9.081,1.511 9.356,1.501C12.205,1.465 15.055,1.465 17.905,1.501C18.161,1.51 18.412,1.555 18.652,1.643C19.277,1.872 19.786,2.368 20.03,2.987C20.132,3.244 20.182,3.514 20.193,3.789C20.254,8.596 20.254,13.404 20.193,18.211C20.182,18.486 20.132,18.756 20.03,19.013C19.786,19.632 19.277,20.128 18.652,20.357C18.412,20.445 18.161,20.49 17.905,20.499C15.073,20.535 12.241,20.5 9.41,20.5C9.155,20.497 8.904,20.458 8.663,20.376C8.013,20.156 7.482,19.65 7.23,19.013C7.129,18.756 7.078,18.486 7.068,18.211C7.051,16.867 7.038,15.522 7.031,14.178C7.706,14.179 8.381,14.179 9.057,14.174C9.062,15.498 9.067,16.821 9.067,18.145C9.067,18.162 9.068,18.179 9.07,18.197C9.09,18.34 9.196,18.457 9.337,18.491C9.365,18.497 9.393,18.5 9.422,18.5C12.228,18.5 15.033,18.5 17.838,18.5C17.856,18.5 17.873,18.499 17.89,18.497C17.918,18.493 17.945,18.486 17.972,18.476C18.102,18.423 18.188,18.301 18.193,18.16C18.254,13.392 18.194,8.624 18.194,3.855C18.194,3.838 18.193,3.821 18.191,3.803C18.167,3.634 18.024,3.507 17.854,3.5C15.044,3.465 12.233,3.5 9.422,3.5C9.405,3.5 9.388,3.501 9.37,3.503C9.201,3.527 9.074,3.669 9.067,3.84C9.05,5.174 9.043,6.509 9.041,7.844C8.371,7.84 7.701,7.835 7.031,7.831Z",
    style: {
      fill: "rgb(232,75,64)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftCall);
export default __webpack_public_path__ + "static/media/left_call.d764875b89d5a81229b363bd4e0a66c7.svg";
export { ForwardRef as ReactComponent };